<template>
    <div class="recommended_list" :class="{'mobile':is_mobile}">
        <div class="recommended_li flex_between" @click="details(liem.news_id)" v-for="(liem,index) in list_arr"
            :key="index">
            <!-- 左边摘要 -->
            <div class="list_left flex_between div_zuoyou" v-if="liem.summary_location == 3">

                <h2 class="list_title clamp1">{{liem.title}}</h2>
                <h3 class="list_title list_time flex_start">
                    <span class="list_tag" v-for="lise in liem.lable"
                        :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                    <div class="time_right">
                        <span class="original">原创:{{liem.user}}</span>
                        <span class="time">{{liem.create_time}}</span>
                    </div>
                </h3>
                <div class="flex_between text_div">
                    <div class="list_describe clamp4" v-html="liem.content">
                    </div>
                    <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="" >
                            <i class="contain_video">
                                <video controlslist='nodownload' oncontextmenu="return false"
                                :poster="liem.video_image?liem.video_image:poster_icon"

                                webkit-playsinline="true"
                                x-webkit-airplay="true"
                                playsinline="true"
                                x5-playsinline
                                ref="video":src="liem.cover_video" preload controls ></video>
                            </i>
                        </div>
                    <div class="list_right flex_center" v-else>
                        <i class="flex_center contain_img" v-if="indexT<2" v-for="(liemT,indexT) in liem.cover">
                                <img v-if="liemT" :src="liemT" alt="">
                                <img v-else src="@/assets/img/app_logo.png" alt="">
                        </i>
                    </div>

                </div>
                <div class="list_time flex_between">

                    <div class="flex_center operation">
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/liulanP.png" alt=""></i>
                            {{liem.see}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                            {{liem.goods}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                            {{liem.comment}}
                        </div>
                    </div>

                </div>
            </div>
            <!-- 右边摘要 -->
            <div class="list_rigth list_left flex_between div_zuoyou" v-if="liem.summary_location == 4">
                <h2 class="list_title clamp1">{{liem.title}}</h2>
                <h3 class="list_title list_time flex_start">
                    <span class="list_tag" v-for="lise in liem.lable"
                        :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                    <div class="time_right">
                        <span class="original">原创:{{liem.user}}</span>
                        <span class="time">{{liem.create_time}}</span>
                    </div>
                </h3>
                <div class="flex_between text_div">
                    <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="" >
                        <i class="contain_video">
                            <video controlslist='nodownload' oncontextmenu="return false"
                            x5-video-player-fullscreen="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            playsinline="true"
                            x5-playsinline
                            :poster="liem.video_image?liem.video_image:poster_icon" ref="video":src="liem.cover_video" preload controls ></video>
                        </i>
                    </div>
                    <div class="list_right flex_center" v-else>
                        <i class="flex_center contain_img" v-if="indexT<2" v-for="(liemT,indexT) in liem.cover">
                                <img v-if="liemT" :src="liemT" alt="">
                                <img v-else src="@/assets/img/app_logo.png" alt="">
                        </i>
                    </div>
                    <div class="list_describe clamp4" v-html="liem.content">
                    </div>
                </div>
                <div class="list_time flex_between">

                    <div class="flex_center operation">
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/liulanP.png" alt=""></i>
                            {{liem.see}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                            {{liem.goods}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                            {{liem.comment}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 上边摘要 -->
            <div class="list_top list_left flex_between" v-if="liem.summary_location == 1">
                <h2 class="list_title clamp1">{{liem.title}}</h2>
                <h3 class="list_title list_time flex_start">
                    <span class="list_tag" v-for="lise in liem.lable"
                        :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                    <div class="time_right">
                        <span class="original">原创:{{liem.user}}</span>
                        <span class="time">{{liem.create_time}}</span>
                    </div>
                </h3>
                <div class="text_div">
                    <div class="list_describe clamp2" v-html="liem.content">
                    </div>
                    <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="" >
                            <i class="contain_video">
                                <video controlslist='nodownload' oncontextmenu="return false"
                                x5-video-player-fullscreen="true"
                                webkit-playsinline="true"
                                x-webkit-airplay="true"
                                playsinline="true"
                                x5-playsinline
                                :poster="liem.video_image?liem.video_image:poster_icon" ref="video":src="liem.cover_video" preload controls ></video>
                            </i>
                        </div>
                    <div class="list_right " v-else>
                        <i class="flex_center contain_img"  :class="{'max' : liem.cover.length == 1}"  v-if="indexT<4" v-for="(liemT,indexT) in liem.cover">
                                <img v-if="liemT" :src="liemT" alt="">
                                <img v-else src="@/assets/img/app_logo.png" alt="">
                        </i>
                    </div>

                </div>
                <div class="list_time flex_between">

                    <div class="flex_center operation">
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/liulanP.png" alt=""></i>
                            {{liem.see}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                            {{liem.goods}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                            {{liem.comment}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下边摘要 -->
            <div class="list_top list_left flex_between" v-if="liem.summary_location == 2">
                <h2 class="list_title clamp1">{{liem.title}}</h2>
                <h3 class="list_title list_time flex_start">
                    <span class="list_tag" v-for="lise in liem.lable"
                        :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                    <div class="time_right">
                        <span class="original">原创:{{liem.user}}</span>
                        <span class="time">{{liem.create_time}}</span>
                    </div>
                </h3>
                <div class="text_div">
                    <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="" >
                        <i class="contain_video">
                            <video controlslist='nodownload' oncontextmenu="return false"
                            x5-video-player-fullscreen="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            playsinline="true"
                            x5-playsinline
                            :poster="liem.video_image?liem.video_image:poster_icon" ref="video":src="liem.cover_video" preload controls ></video>
                        </i>
                    </div>
                    <div class="list_right" v-else>
                        <i class="flex_center contain_img"  :class="{'max' : liem.cover.length == 1}" v-if="indexT<4" v-for="(liemT,indexT) in liem.cover">
                                <img v-if="liemT" :src="liemT" alt="">
                                <img v-else src="@/assets/img/app_logo.png" alt="">
                        </i>
                    </div>
                    <div class="list_describe clamp2" v-html="liem.content">
                    </div>
                </div>
                <div class="list_time flex_between">

                    <div class="flex_center operation">
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/liulanP.png" alt=""></i>
                            {{liem.see}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                            {{liem.goods}}
                        </div>
                        <div class="flex_center operation_li">
                            <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                            {{liem.comment}}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>

</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {
                is_mobile: false,//是否是手机端
                poster_icon:'@/assets/img/app_logo.png',
            }
        },
        props: {
            list_arr: {
                type: Array,
            },
        },
        watch: {

        },
        methods: {
            mobileFun() {
                if (this._isMobile()) {
                    this.is_mobile = true;
                }
            },
            details(id) {//详情
                this.$emit('detailsFun', id);
            },
            videoFun() {
                 
                var au = document.getElementsByTagName("video");
                for (var i = 0; i < au.length; i++) {
                au[i].addEventListener("playing", function () {
                    var this1 = this;
                    this.play();
                    for (var b = 0; b < au.length; b++) {
                    var this2 = au[b];
                    if (this1 !== this2) {
                        this2.pause();
                    }
                    }
                });
                }
            },

        },
        mounted() {
            this.mobileFun();
            this.videoFun();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .recommended_list {}

    .recommended_list .recommended_li {
        padding: 1.2rem 1.5rem;
        border-radius: 4px;
        flex: 1;
        width: 100vw;
        border-bottom: 1px solid #DFDFDF;
        cursor: pointer;
        transition: all .5s ease;
    }

    .recommended_li .list_left {
        flex: 1;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }

    .list_left .list_title {
        font-size: 1.8rem;
        color: #333;
        font-weight: bold;
        align-items: center;
        margin: .4rem 0;
        line-height: 1.6em;
    }

    .list_left .list_title>.list_tag {
        border-radius: .2rem;
        border: .05rem solid #9749BB;
        color: #9749BB;
        display: inline-flex;
        font-size: 1.1rem;
        margin-right: .7rem;
        padding: 0 .7rem;
        line-height: 2rem;
        height: 2rem;
        white-space: nowrap;
    }

    .recommended_li .list_describe {
        font-size: 4vw;
        color: #666;
    }

    .recommended_li .list_time {
        width: 100%;
        margin-top: 1rem;
    }

    .recommended_li .list_time .original {
        font-size: 1.5rem;
        color: #999;
        margin-right: 12px;
    }

    .recommended_li .list_time .time {
        font-size: 1.5rem;
        color: #999;
    }

    .recommended_li .list_time .operation .operation_li {
        font-size: 1.2rem;
        color: #999;
        margin-right: 1.4rem;
        white-space: nowrap;
        line-height: 1.1em;
    }

    .recommended_li .list_time .operation .operation_li>i {
        width: 1.2rem;
        margin-right: 4px;
    }

    .recommended_li .list_right {
        border-radius: .2rem;
        overflow: hidden;
        margin: .6rem auto;
        display: inline-flex;
        width: 100%;
    }

    .recommended_li .list_right img {
        transition: all .5s ease;
        object-fit: cover;
        height: 100%;
    }

    .recommended_list .recommended_li:hover {
        background: #f4f4f4;
    }

    .recommended_list .recommended_li:hover .list_right>img {
        transform: scale(1.2);
    }

    /* 手机端 */
    .recommended_list.mobile {
    }

    .recommended_list.mobile .recommended_li {
        padding: 1.5rem;
        width: calc(100% - 3rem);
    }

    .list_left .list_title.list_time .time_right{
        font-weight: normal;
        margin-left: 1rem;
        font-size: 1.8rem;
    }
    .text_div{
        width: 100%;
    }
    /* 左边摘要 */
    .div_zuoyou.list_left .text_div {
        width: 100%;
        margin: .6rem 0;
    }

    .div_zuoyou.list_left .text_div .list_describe {
        flex: 1;
        height: 27vw;
    line-height: 7vw;
    }

    .div_zuoyou.list_left .text_div .list_right {
        width: auto;
    }

    .div_zuoyou.list_left .text_div .list_right .contain_img {
        width: 10rem;
        height: 7.2rem;
        margin: 0 0 0 1rem;
        background: transparent;
    }

    .div_zuoyou.list_left .text_div .list_right .contain_img>img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .div_zuoyou.list_left .text_div .list_right .contain_video{
        width: 18rem;
        height: 10rem;
        margin-right: 1rem;
    }
    .div_zuoyou.list_left .text_div .list_right .contain_video>video{
        width: 100%;
    }
    /* 右边摘要 */
    .div_zuoyou.list_rigth .text_div .list_right .contain_img {
        margin: 0 1rem 0 0;
    }
    .div_zuoyou.list_rigth .text_div .list_right .contain_video{
        width: 18rem;
        height: 10rem;
        margin-left: 1rem;
    }
    /* <!-- 上边摘要 --> */
    .list_top.list_left .text_div {
        margin-top: 1rem;
    }

    .list_top.list_left .list_describe {
        width: 100%;
    }


    .list_top.list_left .list_right {
        width: 100%;
        flex-wrap: wrap;
    }
    .list_top.list_left .text_div .list_right .contain_img{
        width: calc(25% - 1rem);
    }
    .list_top.list_left .text_div .list_right .contain_video{
        width: 100%;
        height: auto;
    }
    .list_top.list_left .text_div .list_right .contain_video>video{
        width: 100%;
    }
    .list_top.list_left .list_right i {
        width: calc(33% - 1rem);
        height: 6rem;
        margin: 0 1rem 1rem 0;
        display: inline-flex;
    }

    .list_top.list_left .list_right i>img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .recommended_li .list_top.list_left .contain_img.max{
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/assembly/m_listLi.vue